import React from 'react';

import MetaTags from '../shared/MetaTags';
import FooterSection from './FooterSection';
import HeaderSection from './HeaderSection';
import MiddleSection from './MiddleSection';

const CORPORATE_META_TITLE = 'The Information: Corporate Subscriptions & Team Plans';
const CORPORATE_META_DESCRIPTION =
  'Empower your teams to stay ahead with discounted The Information corporate subscription plans. Get group access to insider scoops on upcoming IPOs and startups, deep insights on the biggest tech competitors and more.';
const CorporateLanding = () => {
  return (
    <>
      <MetaTags
        title={CORPORATE_META_TITLE}
        ogSiteName="The Information"
        ogTitle={CORPORATE_META_TITLE}
        twitterTitle={CORPORATE_META_TITLE}
        description={CORPORATE_META_DESCRIPTION}
        ogImagePath="'/global/og_images/Hero_IMG.png'"
      />
      <HeaderSection />
      <MiddleSection />
      <FooterSection />
    </>
  );
};

export default CorporateLanding;
